<template>
  <div class="cmpt-images-gallery" v-show="show">
    <a @click="closeGallery" class="cmpt-images-gallery__close-button">
      <nuttrema-iconica-sidebar-link icon="far fa-times" theme="thin-white"></nuttrema-iconica-sidebar-link>
    </a>
    <el-carousel
       ref="carousel"
       trigger="click"
       indicator-position="none"
      :interval="5000"
      :autoplay="false">
      <el-carousel-item  v-for="image in images" :key="image.id" :name="String(image.id)">
        <div class="cmpt-images-gallery__image" :style="{ 'background-image': getImagePath(image) }"></div>
      </el-carousel-item>
    </el-carousel>
  </div>
</template>

<script>
import { get } from 'lodash';
import NuttremaIconicaSidebarLink from 'components/ui/label/nuttrema-iconica-sidebar-link';

export default {
  name: 'cmpt-images-gallery',
  props: {
    showGallery: {
      required: false,
      default: null,
    },
    images: {
      type: Array,
      required: true,
      default: null,
    },
  },
  components: {
    NuttremaIconicaSidebarLink,
  },
  data() {
    return {
      show: false,
    };
  },
  methods: {
    getImagePath(image) {
      const path = get(image, 'path', '');
      const filename = get(image, 'filename', '');
      return `url(${process.env.IMAGES_ROOT}${path}${filename})`;
    },
    closeGallery() {
      this.$emit('update:showGallery', -1);
    },
    onKeyUp(e) {
      const keyCode = e.keyCode;
      // left - 37
      // right - 39
      // escape - 27
      switch (keyCode) {
        case 37:
          this.$refs.carousel.prev();
          break;
        case 39:
          this.$refs.carousel.next();
          break;
        case 27:
          this.closeGallery();
          break;
        default:
          break;
      }
    },
  },
  watch: {
    showGallery(value) {
      if (value > 0) {
        this.$refs.carousel.setActiveItem(String(value));
        this.show = true;
      } else {
        this.show = false;
      }
    },
  },
  mounted() {
    this.$nextTick(() => {
      document.addEventListener('keyup', this.onKeyUp);
    });
  },
  beforeDestroy() {
    document.removeEventListener('keyup', this.onKeyUp);
  },
};
</script>

<style lang="scss">
  .cmpt-images-gallery {
    top: 0;
    left: 0;
    width: 100%;
    z-index: 200;
    height: 100%;
    position: fixed;
    background-color: rgba(0,0,0,0.75);

    .el-carousel {
      top: 0; bottom: 0;
      left: 0; right: 0;
      position: absolute;

      .el-carousel__container {
        height: 100%;
      }
    }


    .cmpt-images-gallery__close-button {
      top: 1em;
      right: 1em;
      z-index: 150;
      position: absolute;
    }
    .cmpt-images-gallery__image {
      height: 100%;
      background-size: auto 100%;
      background-repeat: no-repeat;
      background-position: center center;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/pages/professional/shared/images/cmpt-images-gallery.vue